document.addEventListener("DOMContentLoaded", () => {
    const sliderWrapper = document.querySelector(".image-multi-wrapper");

    if (sliderWrapper) {
        let activeSlide = 0
        const slider = sliderWrapper.querySelector(".image-multi");
        const slides = slider.querySelectorAll("#details-slider");
        const buttonLeft = sliderWrapper.querySelector(".buttons .icon.left")
        const buttonRight = sliderWrapper.querySelector(".buttons .icon.right")

        let observer = new IntersectionObserver((callback) => {
            callback.forEach(item => {
                const classes = item.target.classList;

                if (item.isIntersecting) {
                    slides.forEach((slide, index) => {
                        if (slide === item.target) {
                            activeSlide = index;
                            (document.querySelector(".image-counter #count") as HTMLElement).innerText = String(activeSlide + 1)
                        }
                    })

                    if (!classes.contains("show")) classes.add("show");
                } else {
                    if (classes.contains("show")) classes.remove("show");

                    const video = item.target.querySelector("video");
                    if (video) {
                        video.pause()
                    }

                    const iframe = item.target.querySelector("iframe") as HTMLIFrameElement;
                    if (iframe) {
                        iframe.contentWindow.postMessage(JSON.stringify({
                            event: 'command',
                            func: 'pauseVideo',
                            args: []
                        }), '*');
                    }
                }
            })
        }, {
            root: slider,
            rootMargin: '0px',
            threshold: 1
        });

        slides.forEach(slide => {
            observer.observe(slide);
        })

        buttonLeft.addEventListener("click", () => {
            const prev = slides.item(activeSlide - 1);

            if (prev) {
                slider.scrollTo(slider.scrollLeft - prev.getBoundingClientRect().width, 0);

                if (buttonRight.classList.contains("disabled")) {
                    buttonRight.classList.remove("disabled")
                }

                if (activeSlide - 1 === 0) {
                    buttonLeft.classList.add("disabled")
                }
            }
        })

        buttonRight.addEventListener("click", () => {
            const next = slides.item(activeSlide + 1)

            if (next) {
                slider.scrollTo(slider.scrollLeft + next.getBoundingClientRect().width, 0)

                if (buttonLeft.classList.contains("disabled")) {
                    buttonLeft.classList.remove("disabled")
                }

                if (activeSlide + 1 === slides.length - 1) {
                    buttonRight.classList.add("disabled")
                }
            }
        })
    }
})
